'use client'

import { useAiChatUi } from '@/entities/ai-chat'

import { Button } from '@/shared/ui'
import Flex from '@/shared/ui/Flex'
import { HorizontalSection } from '@/shared/ui/HorizontalSection/ui/HorizontalSection'

import { contactBlockList } from './data'

import styles from './styles.module.scss'

export const Contacts = () => {
	const { open } = useAiChatUi()

	return (
		<div className={styles.contacts}>
			<section className={styles.contactsTopPanel}>
				<h1 className={styles.contactsTitle}>Контакты</h1>
			</section>
			{contactBlockList.map(item => (
				<HorizontalSection title={item.title} key={item.title}>
					<ContactInfoBlock {...item} />
				</HorizontalSection>
			))}
			<HorizontalSection title="Не нашли то, что искали?">
				<Button className={styles.contactsChatLink} theme="link" onClick={open}>
					Написать в чат
				</Button>
			</HorizontalSection>
		</div>
	)
}

export type TContactInfoBlock = {
	numberList: string[]
	emailList: string[]
	workTime: string
}

const ContactInfoBlock = ({ numberList = [], emailList = [], workTime = `` }: TContactInfoBlock): JSX.Element => (
	<div className={styles.contactInfoBlock}>
		<Flex column>
			{numberList.map(number => (
				<a className={styles.contactInfoBlockPhoneNumber} href={`tel:${number}`} key={number}>
					{number}
				</a>
			))}
			{emailList.map(email => (
				<a className={styles.contactInfoBlockEmail} href={`mailto:${email}`} key={email}>
					{email}
				</a>
			))}
		</Flex>
		<div className={styles.contactInfoBlockWorkTime}>
			<span>{workTime}</span>
		</div>
	</div>
)
